











import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ListBase from '@/lib/listbase';

@Component({
    components: { VuePerfectScrollbar },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
        },
        modalShow: function (val) {
            if (!val) this.$emit('input', false);
        }
    }
})

export default class YouTube extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: '' }) url: string;
    modalShow: boolean = false;
    scrollSettings: any = {
        maxScrollbarLength: 160
    };

    cancel() {
        this.$emit('input', false);
    }

}
